// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoBlock_container__WXk_B","iframe":"VideoBlock_iframe__4DGTT"};